import { getEnvConfig } from "../../apiConfig/urlConfig/envConfig";
import { generatePkcePair } from "../../services/Login/pkceService";

export const redirectToGrowXLogin = async () => {
  const {
    RedirectBaseURL,
    RedirectUrl,
    clientId,
    responseType,
    codeChallengeMethod,
  } = getEnvConfig();

  const redirectUri = `${globalThis.location.origin}/`;

  const { challenge } = await generatePkcePair(true);

  const loginUrl =
    `${RedirectBaseURL}${RedirectUrl}` +
    `?clientId=${clientId}` +
    `&responseType=${responseType}` +
    `&codeChallenge=${challenge}` +
    `&codeChallengeMethod=${codeChallengeMethod}` +
    `&redirectUri=${encodeURIComponent(redirectUri)}`;

  globalThis.location.href = loginUrl;
  // console.log("loginUrl",loginUrl)
};
